(function($, undefined) {
	
	'use strict';
	var exercisesListPageCtn;
	var utils;
	var addLevelBtn;
	var deleteLevelBtn;
	var addExerciseBtn;
	var deleteExerciseBtn;
	var confirmBeforeDeleteItemPopup;
	var confirmationDeleteBtn;
	var exercisesToggleBtn;
	
	/**
	 * Levels
	 */
	var addNewLevel = function() {
		exercisesListPageCtn.addClass('processing');
		var btn = $(this);
		var label = btn.attr('data-label');
		var currentList = btn.attr('data-levels-list');
		var currentListArray = currentList.length > 0 ? currentList.split(',') : [];
		
		var max = utils.getMaxFromArray(currentListArray);
		currentListArray.push(parseInt(max.value) + 1);
		var newList = currentListArray.join(',');
		
		updateLabelLangs(label, newList, "fr", function(){
			location.reload();
		});
	};
	
	var deleteLevel = function(level) {
		var listCtn = $('.levels-list-ctn');
		var currentList = listCtn.attr('data-levels-list');
		var label = listCtn.attr('data-levels-label');
		 
		var currentListArray = currentList.split(',');
		currentListArray.splice(currentListArray.indexOf(level), 1);
		
		var newList = currentListArray.join(',');
		
		updateLabelLangs(label, newList, "fr", function(){
			location.reload();
		});
	};
	
	var showDeleteLevelConfirmationPopup = function(e) {
		e.stopPropagation();
		var t = $(this);
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-id', t.closest('.level-item').attr('data-level'));
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-type', 'label');
		confirmBeforeDeleteItemPopup.addClass('visible');
	};
	
	
	/**
	 * Exercices
	 */
	var createExercise = function() {
		var btn = $(this);
		btn.addClass('processing');
		var ctn = btn.closest('.level-item');
		var level = ctn.attr('data-level');
		var exerciseItems = $('.exercise-list-item', ctn);
		var exerciseNumbers = exerciseItems.map(function(i, el) {
			return parseInt($('.exercise-title', $(el)).text().split(' ')[1]);
		});
		var exercise = exerciseItems.length > 1 ? Math.max(...exerciseNumbers) + 1 : exerciseItems.length + 1; //$('.exercise-list-item', ctn).length + 1;
		var pageId = $('div.page').attr('data-page-id-num');
		
		var friendlyUrl = `niveau-${level}-exercice-${exercise}`;
		
		var params = {
			ajax: true,
			field1: "exercise",
			field2: `Exercice ${exercise}`,
			field3: level,
			field5: pageId,
			friendlyUrl: friendlyUrl
		};
		
		$.ajax({
			url: "/action/manageGenData",
			method: "post",
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				if (response.responseText.indexOf('success') !== -1) {
					location.reload();
				}	
				else {
					btn.removeClass('processing');
				}
			}
		});
	};
	
	var showDeleteExerciseConfirmationPopup = function(e) {
		e.stopPropagation();
		var t = $(this);
		var ctn = t.closest('.exercise-list-item');
		var ctnBig = ctn.closest('.level-item');
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-id', t.closest('.exercise-list-item').attr('data-id'));
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-type', 'gendata');
		confirmBeforeDeleteItemPopup.find('.delete-btn').attr('data-is-last', ctn.index() == $('.exercise-list-item', ctnBig).last().index());
		confirmBeforeDeleteItemPopup.addClass('visible');
	};
	
	var onDeleteItemPopupConfirm = function() {
		var t = $(this);
		var parent = t.closest('.popup-inner');
		var type = t.attr('data-type');
		parent.addClass('processing');
		var id = t.attr('data-id');
		
		if (type === "gendata") {
			var isLast = t.attr('data-is-last');
			var firstItemToChange = $('.exercise-list-item[data-id=' + id + ']').next();
			
			utils.deleteGenData(id, function(response) {
				if (response.indexOf('success') !== -1) {
					if (isLast !== 'true') {
						updateGenDatasPositions(firstItemToChange, function() {
							location.reload();
						});
					}
					else {
						location.reload();
					}
				} else {
					parent.removeClass('processing');
				}
			});
		}
		else if (type === "label") {
			deleteLevel(t.attr('data-id'));
		}
		else {
			console.log('Unrecognized type: ' + type);
		}
	};
	
	var updateGenDatasPositions = function(item, callback = () => {}) {
		var ctn = item.closest('.level-item');
		var newIndex = (parseInt(item.attr('data-index')) - 1);
		var params = {
			"id": item.attr('data-id'),
			"field2": "Exercice " + newIndex,
			"friendlyUrl": "niveau-" + ctn.attr('data-level') + "-exercice-" + newIndex,
			ajax: true
		};
		$.ajax({
			url: "/action/manageGenData",
			method: "post",
			data: params,
			success: function(response) {
				if (item.next().length > 0) {
					updateGenDatasPositions(item.next(), callback);
				}
				else {
					callback();
				}
			},
			error: function(jqxhr, status, error) {
				console.log(status + " " + error);
			}
		});
	};
	
	var toggleExercisesList = function() {
		var t = $(this);
		var ctn = 	t.closest('.level-item');
		var contentToToggle = $('.level-item-content', ctn);
		ctn.toggleClass('open');
		contentToToggle.slideToggle(300);
	};
	
	var init = function () {
		utils = Fw.component.models().utils;
		exercisesListPageCtn = $('.exercises-list-ctn');
		addLevelBtn = $('.admin-add-level-btn');
		deleteLevelBtn = $('.delete-level-btn');
		addExerciseBtn = $('.add-exercise-btn');
		deleteExerciseBtn = $('.delete-exercise-btn');
		confirmBeforeDeleteItemPopup = $('#admin-confirm-exercise-delete-item-popup');
		confirmationDeleteBtn = $('.delete-btn', confirmBeforeDeleteItemPopup);
		exercisesToggleBtn = $('.toggle-exercises-detail-btn');
		
		addLevelBtn.on('click', addNewLevel);
		deleteLevelBtn.on('click', showDeleteLevelConfirmationPopup);
		addExerciseBtn.on('click', createExercise);
		deleteExerciseBtn.on('click', showDeleteExerciseConfirmationPopup);
		confirmationDeleteBtn.on('click', onDeleteItemPopupConfirm);
		exercisesToggleBtn.on('click', toggleExercisesList);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
